import { config } from "./config";
import tokenABI from "./ABIs/tokenABI.json";
import pepeABI from "./ABIs/pepeABI.json";

const { tokenContractAddress, pepeContractAddress } = config;

const TokenContractHandlerMap = new Map<string, TokenContractHandler>();

/**
 * @see https://goerli.etherscan.io/token/0xce09d1af0bf825d948a8de82294511aef7495cd0#code
 */
export class TokenContractHandler {
  contract: import("./ABIs/tokenABI").ContractContext | null;
  pepecontract: import("./ABIs/pepeABI").ContractContext | null;
  contractAddress: string;
  web3: import("web3").default | null;
  constructor() {
    if (TokenContractHandlerMap.has(tokenContractAddress)) {
      return TokenContractHandlerMap.get(tokenContractAddress);
    } else {
      TokenContractHandlerMap.set(tokenContractAddress, this);
    }
    this.contract = null;
    this.pepecontract = null;
    this.contractAddress = tokenContractAddress;
    this.web3 = null;
  }

  async buildContract(web3: import("web3").default) {
    if (this.web3 === web3 && this.contract) return true;
    this.web3 = web3;
    if (tokenABI && this.web3) {
      const artifact = tokenABI;
      const artifactPepe = pepeABI;
      this.contract = new web3.eth.Contract(
        artifact as any,
        tokenContractAddress
      ) as any;
      this.pepecontract = new web3.eth.Contract(
        artifactPepe as any,
        pepeContractAddress
      ) as any;
      if (this.contract) {
        return true;
      }
      return false;
    }
    console.log("ABI pack json failed to load");
    return false;
  }

  async getMintPrice() {
    return await this.contract.methods.price().call();
  }

  async getTotalSupply() {
    return await this.contract.methods.maxSupply().call();
  }

  async getTotalMinted() {
    return await this.contract.methods.totalSupply().call();
  }

  async getApproval({
    account,
    quantity,
    receiptCallback,
    transactionCallback,
    approvaltransactionCallback,
    approvedCallback,
  }: {
    account: string;
    quantity: number;
    receiptCallback: (
      receipt: import("ethereum-abi-types-generator").TransactionReceipt
    ) => void;
    approvaltransactionCallback: (hash: string) => void;
    transactionCallback: (hash: string) => void;
    approvedCallback: () => void;
  }): Promise<void> {
    // update the price just before purchase
    const perPackPrice = await this.getMintPrice();
    // adjust price for quantity

    const price = this.web3.utils
      .toBN(perPackPrice)
      .mul(this.web3.utils.toBN(quantity))
      .toString();

    //    Math.max(0, +perPackPrice * quantity);
    let methodGasPrice = null;
    let currentGasPrice = null;

    // Get the estimated gas
    try {
      methodGasPrice = await this.pepecontract.methods
        .approve(this.contractAddress, price + "")
        .estimateGas({
          from: account,
        });
    } catch (err) {
      console.warn("ERROR Method Gas Price", err);
      throw err;
    }

    try {
      currentGasPrice = await this.web3.eth.getGasPrice();
    } catch (err) {
      console.warn("ERROR Current Gas Price", err);
      throw err;
    }

    const sendTransactionData = {
      gas: parseInt("" + methodGasPrice),
      gasPrice: parseInt("" + 1.23 * +currentGasPrice) + "",
      from: account,
    };

    try {
      await this.pepecontract.methods
        .approve(this.contractAddress, price + "")
        .send(sendTransactionData)
        .once("transactionHash", (hash) => {
          console.log("transactionHash", hash);
          approvaltransactionCallback(hash);
        })
        .on("receipt", async (receipt) => {
          if (receipt?.from.toLowerCase() === account.toLowerCase()) {
            // receiptCallback(receipt);
            approvedCallback();
            await this.mint({
              account,
              quantity,
              receiptCallback,
              transactionCallback,
            });
            return true;
          }
        })
        .on("confirmation", (confNumber, receipt) => {
          console.log("confirmation", confNumber, receipt);
        })
        .on("error", (error) => {
          console.warn("error", error);
          return false;
        })
        .then((receipt) => {
          // check for required mined data
          console.log("mined:", receipt);
        });
    } catch (err) {
      console.warn("ERROR MINT function", err);
      throw err;
    }
  }

  async mint({
    account,
    quantity,
    receiptCallback,
    transactionCallback,
  }: {
    account: string;
    quantity: number;
    receiptCallback: (
      receipt: import("ethereum-abi-types-generator").TransactionReceipt
    ) => void;
    transactionCallback: (hash: string) => void;
  }): Promise<void> {
    let methodGasPrice = null;
    let currentGasPrice = null;

    // Get the estimated gas
    try {
      methodGasPrice = await this.contract.methods
        .Mint(quantity + "")
        .estimateGas({
          from: account,
        });
    } catch (err) {
      console.warn("ERROR Method Gas Price", err);
      throw err;
    }

    try {
      currentGasPrice = await this.web3.eth.getGasPrice();
    } catch (err) {
      console.warn("ERROR Current Gas Price", err);
      throw err;
    }

    const sendTransactionData = {
      gas: parseInt("" + methodGasPrice),
      gasPrice: parseInt("" + 1.13 * +currentGasPrice) + "",
      from: account,
    };

    try {
      await this.contract.methods
        .Mint(quantity + "")
        .send(sendTransactionData)
        .once("transactionHash", (hash) => {
          console.log("transactionHash", hash);
          transactionCallback(hash);
        })
        .on("receipt", (receipt) => {
          if (receipt?.from.toLowerCase() === account.toLowerCase()) {
            receiptCallback(receipt);
            return true;
          }
        })
        .on("confirmation", (confNumber, receipt) => {
          console.log("confirmation", confNumber, receipt);
        })
        .on("error", (error) => {
          console.warn("error", error);
          return false;
        })
        .then((receipt) => {
          // check for required mined data
          console.log("mined:", receipt);
        });
    } catch (err) {
      console.warn("ERROR MINT function", err);
      throw err;
    }
  }
}
